import { Form } from '@themesberg/react-bootstrap'
import React from 'react'
import { useResponsive } from '../hooks/useResponsive'

function TextInput(props) {
  const {
    label = '',
    labelClass = '',
    required = false,
    type = 'text',
    placeHolder = '', 
    name = '',
    error = '',
    isInvalid = false,
    size = 'sm'
  } = props
  
  const { isMobile } = useResponsive();
  
  return (
    <Form.Group id={name+"city"} className={isMobile ? 'form-mobile' : ''}>
      <Form.Label className={`${labelClass} ${required ? 'required' : ''}`}>
        {label}
        {required && <span className="text-danger ms-1">*</span>}
      </Form.Label>
      <Form.Control
        type={type} 
        size={isMobile ? 'lg' : size}
        placeholder={placeHolder}
        required={required}
        isInvalid={isInvalid}
        style={{
          minHeight: isMobile ? '48px' : 'auto',
          fontSize: isMobile ? '16px' : '14px',
          borderWidth: isMobile ? '2px' : '1px'
        }}
        {...props}
      />
      {error && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {error}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  )
}

export default TextInput
